import React from "react";
import styles from "./style.module.scss";
import { useNavigate } from "react-router-dom";

const CoffeeModuleCard = ({ icon, title, link }) => {
  const navigate = useNavigate();
  return (
    <div className={styles.moduleCard} onClick={() => navigate(link)}>
      <span className={styles.topKey}></span>
      <div className={styles.moduleContent}>
        {icon && icon}
        <h2>{title}</h2>
      </div>
      <span className={styles.bottomKey1}></span>
      <span className={styles.bottomKey2}></span>
    </div>
  );
};

export default CoffeeModuleCard;
